import customSelectStyle from 'shared/mdr/assets/jss/material-dashboard-react/customSelectStyle';

const styles = {
  ...customSelectStyle,
};

export default styles;